<template>
    <section class="px-4 pb-6 bg-blue-50 xl:px-16 md:px-8 lg:pb-8">
        <div class="rounded-lg" style="background-color: #D7DCE8">
        <div class="p-4 mx-auto md:p-8">
            <div class="grid grid-cols-12">
                <div class="order-2 col-span-12 xl:col-span-6 xl:order-1">
                   
                   <div class="relative xl:-right-2">
                    <div class="flex gap-x-4 gap-y-4 justify-center xl:justify-start md-max:flex-wrap">
                        <nuxt-img 
                                :src="images[0]" 
                                alt="Creator post" 
                                class="rounded-lg"
                                loading="lazy"
                                width="233"
                                height="171"
                                format="webp"
                                sizes="xs:170px sm:170px md:170px lg:170px xl:251px"
                            />

                                <nuxt-img 
                                :src="images[1]" 
                                alt="Creator post" 
                                class="rounded-lg"
                                loading="lazy"
                                width="218"
                                height="172"
                                format="webp"
                                sizes="xs:170px sm:170px md:170px lg:170px xl:251px"
                            />
                    </div>

                    <div class="flex gap-x-4 justify-center mt-5 xl:justify-start">
                        <div class="relative z-10" >
                            <nuxt-img 
                                :src="images[2]" 
                                alt="Creator post" 
                                class="rounded-lg"
                                loading="lazy"
                                width="306"
                                height="225"
                                format="webp"
                                sizes="xs:170px sm:170px md:170px lg:170px xl:251px"
                            />
                        </div>

                        <div>
                            <nuxt-img 
                                :src="images[3]" 
                                alt="Creator post" 
                                class="rounded-lg"
                                loading="lazy"
                                width="159"
                                height="109"
                                format="webp"
                                sizes="xs:170px sm:170px md:170px lg:170px xl:251px"
                            />

                            <nuxt-img 
                                :src="images[4]" 
                                alt="Creator post" 
                                class="mt-4 rounded-lg xl:-ml-12"
                                loading="lazy"
                                width="121"
                                height="83"
                                format="webp"
                                sizes="xs:170px sm:170px md:170px lg:170px xl:251px"
                            />
                        </div>

                    </div>
                   </div>

                </div>

                <div class="order-1 col-span-12 pt-4 xl:col-span-6 xl:order-2">
                    <h4 class="mb-4 text-2xl font-bold text-center md:text-xl lg:text-2xl font-ww-bold" v-html="title">
                    </h4>

                    <div>
                        <nuxt-img 
                                :src="mainImage" 
                                alt="Creator post" 
                                class="mx-auto rounded-lg xl:absolute xl:right-20"
                                loading="lazy"
                                width="562"
                                height="380"
                            />
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: 'Top Creators LOVE Lifeboost!!'
    },
    images: {
        type: Array,
        default: () => [
            '/assets/images/creators-bogo-1.jpg',
            '/assets/images/creators-bogo-2.jpg',
            '/assets/images/creators-bogo-3.jpg',
            '/assets/images/creators-bogo-4.jpg',
            '/assets/images/creators-bogo-5.jpg',
        ]
    },
    mainImage: {
        type: String,
        default: '/assets/images/creators-bogo-6.png'
    }
});

defineBuilderComponent({
    friendlyName: 'Media Images With Title',
    inputs: [
        {
            name: 'title',
            type: 'text',
            defaultValue: 'Top Creators LOVE Lifeboost!!',
            friendlyName: 'Title'
        },
        {
            name: 'mainImage',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/creators-bogo-6.png',
            friendlyName: 'Main Right Image'
        },
        {
            name: 'images',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
                    required: true
                }
            ],
            defaultValue: [
                '/assets/images/creators-bogo-1.jpg',
                '/assets/images/creators-bogo-2.jpg',
                '/assets/images/creators-bogo-3.jpg',
                '/assets/images/creators-bogo-4.jpg',
                '/assets/images/creators-bogo-5.jpg',
            ],
            friendlyName: 'Left Side Collage Images (5 items)'
        }
    ]
});
</script>
